// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  civ: __t.string().primaryKey(),
  worldId: __t.u64().name("world_id"),
  treasury: __t.i64(),
  speakerId: __t.u64().name("speaker_id"),
  speakerSid: __t.u64().name("speaker_sid"),
  speakerName: __t.string().name("speaker_name"),
  speakerSinceEpoch: __t.i64().name("speaker_since_epoch"),
  lastSpeakerId: __t.u64().name("last_speaker_id"),
  lastSpeakerUntilEpoch: __t.i64().name("last_speaker_until_epoch"),
  legitimacy: __t.f32(),
  levyBps: __t.i32().name("levy_bps"),
  customsBps: __t.i32().name("customs_bps"),
  sessionEpoch: __t.i64().name("session_epoch"),
  reserveGrain: __t.f32().name("reserve_grain"),
  drillDay: __t.i32().name("drill_day"),
  festivalDay: __t.i32().name("festival_day"),
  atWarWith: __t.string().name("at_war_with"),
  updatedAt: __t.timestamp().name("updated_at"),
});
